import { api } from "@/axios";
import responseHandler from "@/responseHandler.js";

const state = {
  cities: [],
};

const getters = {
  getCities: (state) => state.cities,
  getCityById: (state) => (id) => state.cities.find((x) => x.id == id),
};

const actions = {
  async fetchCities({ commit }) {
    try {
      const resp = await api.get("/cities");
      console.log("resp:::", resp);
      if (resp.status == 200) {
        const cities = resp.data.data;
        console.log("cities:::", cities);
        commit("setCities", cities);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async updateCity({ commit }, citiy) {
    console.log("xxx:", citiy);
    try {
      const id = citiy.id;
      citiy._method = "patch";

      const resp = await api.post(`/cities/${id}`, citiy);
      if (resp.status == 200) {
        const citiy = resp.data.data;
        console.log("updated:", citiy);
        commit("updateCity", citiy);
      }
      return responseHandler.respH1(resp);
    } catch (error) {
      console.log("error", error);
      return responseHandler.respH1(error.response);
    }
  },
  async addCity({ commit }, citiy) {
    try {
      const resp = await api.post(`/cities`, citiy);

      if (resp.status == 201) {
        const citiy = resp.data.data;

        commit("addCity", citiy);
      }
      console.log("resp:", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
  async deleteCity({ commit }, id) {
    try {
      const resp = await api.delete(`/cities/${id}`);

      if (resp.status == 204) {
        commit("deleteCity", id);
      }
      console.log("resp", resp);
      return responseHandler.respH1(resp);
    } catch (error) {
      return responseHandler.respH1(error.response);
    }
  },
};

const mutations = {
  setCities(state, cities) {
    state.cities = cities;
  },
  updateCity(state, citiy) {
    const id = citiy.id;
    const index = state.cities.findIndex((citiy) => citiy.id == id);
    if (index !== -1) {
      state.cities[index] = citiy;
    }
  },
  addCity(state, citiy) {
    state.cities.unshift(citiy);
  },

  deleteCity(state, id) {
    const index = state.cities.findIndex((p) => p.id == id);
    if (index !== -1) {
      state.cities.splice(index, 1);
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
